import { cn } from '@/lib/utils';

type Props = {
  id: string;
  checked: boolean;
  onChange: () => void;
  label?: string;
  disabled?: boolean;
  testId?: string;
};

function RadioInput({ id, checked, onChange, label = '', disabled = false, testId }: Props) {
  return (
    <label
      className={cn(
        'flex items-center gap-2 cursor-pointer',
        disabled && 'opacity-50 cursor-not-allowed',
      )}
      htmlFor={id}
      onClick={(e) => {
        if (disabled) e.preventDefault();
      }}
      data-testid={testId}
    >
      <input
        type='radio'
        id={id}
        checked={checked}
        onChange={() => !disabled && onChange()}
        disabled={disabled}
        className='h-4 w-4 shrink-0 rounded-full border border-primary text-primary focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-none disabled:cursor-not-allowed'
      />
      {label && (
        <span
          className={cn('text-sm text-foreground select-none', disabled && 'text-muted-foreground')}
        >
          {label}
        </span>
      )}
    </label>
  );
}

export default RadioInput;
